import { ArrowRight, Upload } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { importBackup, settingsRepository } from '../services/storage/repositories'
import type { BackupFile } from '../types/domain'
import { useToast } from './Toast'

export function FirstRun() {
  const [open, setOpen] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const toast = useToast()
  useEffect(() => { void settingsRepository.get('app').then(settings => setOpen(!settings?.firstRunComplete)) }, [])
  const complete = async () => { await settingsRepository.save({ id:'app', theme:'dark', firstRunComplete:true }); setOpen(false) }
  const load = async (file?: File) => {
    if (!file) return
    try { const backup = JSON.parse(await file.text()) as BackupFile; await importBackup(backup); await settingsRepository.save({ id:'app', theme:'dark', firstRunComplete:true }); window.location.reload() }
    catch { toast('Не удалось загрузить backup') }
  }
  if (!open) return null
  return <div className="welcome-backdrop"><section className="welcome-card" role="dialog" aria-modal="true" aria-label="Добро пожаловать">
    <div className="welcome-mark"><span/><img src="/assets/prime-squad-logo.png" alt="PRIME SQUAD"/></div>
    <span className="eyebrow">PRIME SQUAD</span><h1>Prime Hub</h1><p>Центр управления составом и тактикой команды.</p>
    <button className="button primary" onClick={() => void complete()}>Начать работу <ArrowRight/></button>
    <button className="button ghost" onClick={() => inputRef.current?.click()}><Upload/>Загрузить backup</button>
    <input ref={inputRef} hidden type="file" accept="application/json,.json" onChange={event => void load(event.target.files?.[0])}/>
    <small>Данные сохраняются в защищённом командном хабе.</small>
  </section></div>
}
